<template>
    <div class="col-md-9">
        <h1 class="pages__title">Team Member</h1>
        <div class="pages__box">
            <div class="form">
                <ValidationObserver ref="form">

                    <LogoAvatarUploader
                        :label="'logo'"
                        :logo="member.avatar"
                        :upload-handler="uploadImage"
                        @update-image="updateAvatar"
                    />

                    <ValidationProvider
                        class="form-group mb-3"
                        name="First Name"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">First Name</label>
                        <input
                            type="text"
                            v-model="member.first_name"
                            class="form-control pl-4"
                        >
                        <FormError :error="errors[0]" name="First Name"></FormError>
                    </ValidationProvider>
                    <ValidationProvider
                        class="form-group mb-3"
                        name="Last Name"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Last Name</label>
                        <input
                            type="text"
                            v-model="member.last_name"
                            class="form-control pl-4"
                        >
                        <FormError :error="errors[0]" name="Last Name"></FormError>
                    </ValidationProvider>

                    <ValidationProvider
                        class="form-group mb-3"
                        name="Phone"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Phone</label>
                        <input
                            type="text"
                            v-model="member.phone"
                            class="form-control pl-4"
                        >
                        <FormError :error="errors[0]" name="Phone"></FormError>
                    </ValidationProvider>


                    <ValidationProvider
                        class="form-group mb-3"
                        name="Position"
                        v-slot="{ errors }"
                        rules="required"
                    >
                        <label for="" class="form-label">Position</label>
                        <input
                            type="text"
                            class="form-control pl-4"
                            v-model="member.position"
                        >
                        <FormError :error="errors[0]"  name="Position"></FormError>
                    </ValidationProvider>

                    <div class="form-group mb-3">
                        <label for="" class="form-label">Linkedin link</label>
                        <input type="text" class="form-control" v-model="member.linkedin_link">
                        <span class="form-icon social">
                            <img src="/img/svg/linkedin.svg" alt="Linkedin Icon" width="24">
                        </span>
                    </div>

                    <div class="form-group mb-3">
                        <label class="form-label">Biography</label>
                        <TinyMce
                            :props-value="member.biography"
                            :upload-handler="uploadImage"
                            @update-content="member.biography = $event"
                        />
                    </div>

                    <BaseButtons
                        :on-cancel="backToPreviousPage"
                        :on-save="validateForm"
                    />

                </ValidationObserver>
            </div>
        </div>
    </div>
</template>

<script>

import {defineComponent} from "vue";
import BaseButtons from "../../Common/BaseButtons.vue";
import FormError from "../../Common/FormError.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import AdminPanelService from "../../../services/AdminPanelService";
import LogoAvatarUploader from "../../Common/ContentFields/LogoAvatarUploader.vue";
import TinyMce from "../../Common/ContentFields/TinyMce.vue";

export default defineComponent({
    name: 'TeamsEditor',
    mixins: [ModalHandler],
    components: {TinyMce, LogoAvatarUploader, FormError, BaseButtons},
    props: {
        memberId: Number
    },
    data() {
        return {
            member: {
                avatar: null,
                first_name: null,
                last_name: null,
                phone: null,
                position: null,
                linkedin_link: null,
                biography: ""
            },
        }
    },
    methods: {
        updateAvatar(result) {
            this.member.avatar = result
        },
        async uploadImage(formData) {
            return await AdminPanelService.uploadLogo(formData)
        },
        async getMemberInfo() {
            try {
                const { data : response} = await AdminPanelService.getMemberInfo(this.memberId)
                this.member = response
            } catch (error) {
                console.error(error)
            }
        },
        async validateForm() {
            this.$showLoadingMessage()
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showValidationErrorMessage();
                return;
            }

            if (this.memberId) {
                await this.updateMemberInfo()
            } else {
                await this.createMember()
            }
        },

        async createMember() {
            try {
                await AdminPanelService.createMember(this.member)
                this.$showSuccessMessage('The information was saved')
            } catch (e) {
                console.error(e)
            }
        },
        async updateMemberInfo() {
            try {
                await AdminPanelService.updateMemberInfo(this.memberId, this.member)
                this.$showSuccessMessage('The information was updated')
            } catch (e) {
                console.error(e)
            }
        }
    },
    mounted() {
        if( this.memberId) {
            this.getMemberInfo()
        }
    }
})
</script>



<style scoped>

</style>
